export default __webpack_public_path__ + "static/media/taxi_noun.338d51f1.png";